<ng-container *ngIf="!bootcamps || bootcamps.length === 0">
  <ion-row class="ion-align-items-center">
    <ion-col size="12">
      <ng-container *ngFor="let i of loadingArtifacts">
        <div class="ph-item">
          <div class="ph-col-12">
              <div class="ph-picture"></div>
              <div class="ph-row">
                  <div class="ph-col-6 big"></div>
                  <div class="ph-col-4 empty big"></div>
                  <div class="ph-col-2 big"></div>
                  <div class="ph-col-4"></div>
                  <div class="ph-col-8 empty"></div>
                  <div class="ph-col-6"></div>
                  <div class="ph-col-6 empty"></div>
                  <div class="ph-col-12"></div>
              </div>
          </div>
        </div>
      </ng-container>
    </ion-col>
  </ion-row>
</ng-container> 
<ion-row class="ion-justify-content-left" *ngIf="!showSpinner">
  <ng-container *ngIf="bootcamps && bootcamps.length > 4">
    <ion-col size="12" class="ion-padding">
      <ion-slides pager="true" [options]="bootcampSliderOptions" class="bootcampSlider" #bootcampSlider id="bootcampSlider" (ionSlideDidChange)="ionSlideDidChange()">
        <ion-slide *ngFor="let bootcamp of bootcamps; last as isLast" >
          <bootcamp [view]="'communityPage'" [community]="community" [showSchedule]="showSchedule" [comingsoon]="comingsoon" [bootcamp]="bootcamp" (cancelTimer)="emitCancelTimer()"></bootcamp>
        </ion-slide>
      </ion-slides>
    </ion-col>
    <ion-col style="top:-36px" size="12" class="nucamp-swiper-navigation ion-no-padding">
      <ion-row class="ion-no-padding">
        <ion-col size="3.2" size-sm="5" (click)="swipePrevBootcamps()" class="ion-text-right nucamp-swiper-button-prev ion-no-padding"><fa-icon [icon]="faAngleDoubleLeft" style="color:var(--ion-color-primary);"></fa-icon></ion-col>
        <ion-col size="5.6" size-sm="2"></ion-col>
        <ion-col size="3.2" size-sm="5" (click)="swipeNextBootcamps()" class="ion-text-left nucamp-swiper-button-next ion-no-padding"><fa-icon [icon]="faAngleDoubleRight" style="color: var(--ion-color-primary);"></fa-icon></ion-col>
      </ion-row>
  </ion-col>
  </ng-container>
  <ng-container *ngIf="bootcamps && bootcamps.length <= 4">
    <ng-container *ngFor="let bootcamp of bootcamps; last as isLast">
      <ion-col *ngIf="bootcamps && bootcamps.length === 4" size="12" size-xl="3" size-md="6" class="ion-padding-vertical ion-padding">
        <bootcamp [view]="'communityPage'" [community]="community" [showSchedule]="showSchedule" [comingsoon]="comingsoon" [bootcamp]="bootcamp" (cancelTimer)="emitCancelTimer()"></bootcamp>
      </ion-col>
      <ion-col *ngIf="bootcamps && bootcamps.length === 3" size="12" size-lg="4" size-md="6" class="ion-padding-vertical ion-padding">
        <bootcamp [view]="'communityPage'" [community]="community" [showSchedule]="showSchedule" [comingsoon]="comingsoon" [bootcamp]="bootcamp" (cancelTimer)="emitCancelTimer()"></bootcamp>
      </ion-col>
    </ng-container>
  </ng-container>
</ion-row>
